import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import dotracking from "../../../../trackinglogs";
import trackobj from "../../../../trackingpages.json";
import {
  receiptapprej,
  receiptdelete,
  tourviewdetail,
} from "../../../../../services/superadmin";
import Swal from "sweetalert2";
import { receiptlisttour, toursummary } from "../../../../../services/common";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import exportUrl from "../../../../../exportUtl";
import { coachtourviewdetail } from "../../../../../services/coach";

export const ReceiptTourlist = () => {
  const { id } = useParams();
  const [filterProduct, setFilterProduct] = useState([]);
  const [spath, setSPath] = useState("");

  const [tname, setTName] = useState("");
  const [ddate, setDDate] = useState("");
  const [tsport, setTSport] = useState("");

  const [urllink, setUrlLink] = useState("");

  useEffect(() => {
    const url = window.location.href;
    const head = url.split("/#/");
    const link = head[1].split("/");
    setUrlLink(link[1]);
    if (localStorage.getItem("Role") === "1") {
      tourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
          setDDate(response.data.tournament.entry_deadline_date);
          setTSport(response.data.tournament.sports_type);
          listall(response.data.tournament.sports_type);
        }
      });
    }else if (localStorage.getItem("Role") === "7") {
      coachtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setTName(response.data.tournament.meet_name);
          setDDate(response.data.tournament.entry_deadline_date);
          setTSport(response.data.tournament.sports_type);
          listall(response.data.tournament.sports_type);
        }
      });
    }
  }, []);

  function listall(ltype) {
    setFilterProduct([]);
    if (ltype.toUpperCase() === "ATHLETICS") {
      receiptlisttour(id).then((response) => {
        if (response.status === true) {
          setSPath(response.data.receipt_path);
          setFilterProduct(response.data.exteral_receipt);
        }
      });
    }
  }

  function backlist() {
    dotracking(
      "back button in school tournament list for " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.tourlistheading
    );
    if (localStorage.getItem("Role") === "1") {
      navigate("/superadmin/tournamentlist");
    }else if (localStorage.getItem("Role") === "7") {
      navigate("/coach/tournamentlist");
    }
  }

  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [rtype, setRType] = useState("");
  const [rdesc, setRDesc] = useState("");
  const [schid, setSchool] = useState("");
  const [schname, setSchoolName] = useState("");

  const [recid, setRecID] = useState("");

  function handleshow(type, tdata) {
    setRType(type);
    setSchool(tdata.school_id);
    setSchoolName(tdata.school_name);
    setRecID(tdata.id);
    setRDesc("");
    setShow(!show);
  }

  function handleclose() {
    setRDesc("");
    setRType("");
    setSchool("");
    setRecID("");
    setSchoolName("");
    setShow(false);
  }
  const [errmsg, setErrMsg] = useState([]);
  function submitrec(e) {
    e.preventDefault();
    setErrMsg("");
    if (rdesc !== "") {
      const temp = new FormData();
      temp.append("tournament_meet_id", id);
      temp.append("school_id", schid);
      temp.append("receipt_id", recid);
      temp.append("admin_id", localStorage.getItem("UID"));
      temp.append("approve_or_reject", rtype);
      temp.append("approve_or_reject_reason", rdesc);
      let rbut = "";
      if (rtype == 1) {
        rbut = "approve";
      } else if (rtype == 2) {
        rbut = "reject";
      }
      dotracking(
        rbut +
          " button in tournament receipt list for school - " +
          schname +
          " (" +
          schid +
          ") in " +
          tname +
          " (" +
          id +
          ") tournament $$ " +
          trackobj.tourreceiptlistheading
      );
      receiptapprej(temp).then((res) => {
        if (res.status === true) {
          handleclose();
          closesum();
          toast.success(res.message);
          listall(tsport);
        }
      });
    } else {
      setErrMsg("Please Enter Description");
    }
  }

  const [oshow, setOshow] = useState(false);
  const [oimage, setOImage] = useState("");
  function openimage(image) {
    setOImage(image);
    setOshow(true);
  }

  function closeimage() {
    setOImage("");
    setOshow(false);
  }

  function deleterec(ddata) {
    Swal.fire({
      title: "Are you sure want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        dotracking(
          "delete icon in tournament receipt list for school - " +
            ddata.school_name +
            " (" +
            ddata.school_id +
            ") in " +
            tname +
            " (" +
            id +
            ") tournament $$ " +
            trackobj.tourreceiptlistheading
        );
        receiptdelete(ddata.id, id, ddata.school_id).then((res) => {
          if (res.status === true) {
            toast.success(res.message);
            listall(tsport);
          }
        });
      }
    });
  }
  const [sumrep, setSumRep] = useState("");
  const [cmen, setCMen] = useState(0);
  const [cwomen, setCWomen] = useState(0);
  const [disamt, setDisAmt] = useState(0);
  const [disper, setDisPer] = useState(0);
  const [finalamt, setFinalAmt] = useState(0);
  const [emencnt, setEMenCnt] = useState(0);
  const [ewomencnt, setEWomenCnt] = useState(0);
  const [etcnt, setETCnt] = useState(0);
  const [regfinalamt, setRegFinalAmt] = useState(0);

  const [sumshow, setSumShow] = useState(false);

  function viewrec(ddata) {
    dotracking(
      "view summary icon in tournament receipt list for school - " +
        ddata.school_name +
        " (" +
        ddata.school_id +
        ") in " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.tourreceiptlistheading
    );
    setSumRep(ddata);
    setSumShow(true);
    toursummary(id, ddata.school_id).then((response) => {
      if (response.status === true) {
        setCMen(response.data.no_of_men);
        setCWomen(response.data.no_of_women);
        setDisPer(response.data.discount_percentage);
        setDisAmt(response.data.discount_amount);
        setFinalAmt(response.data.final_amount);
        setRegFinalAmt(response.data.registration_fee);

        setEMenCnt(response.data.total_male_event_count);
        setEWomenCnt(response.data.total_female_event_count);
        setETCnt(
          parseInt(response.data.total_male_event_count) +
            parseInt(response.data.total_female_event_count)
        );
      }
    });
  }

  function closesum() {
    setSumShow(false);
    setSumRep("");
    setCMen(0);
    setCWomen(0);
    setDisPer(0);
    setDisAmt(0);
    setFinalAmt(0);
    setRegFinalAmt(0);

    setEMenCnt(0);
    setEWomenCnt(0);
    setETCnt(0);
  }

  function explist(){
    dotracking("export icon in receipt list for " + tname + " (" + id + ") tournament $$ " + trackobj.tourreceiptlistheading);
    window.open(exportUrl + "export-external-payment-receipt-list/" + id, "_blank");

  }

  return (
    <Fragment>
      <div className="side-app">
        <div className="page-header">
          <div className="breadcrumb">
            <h4 className="mb-0">Tournament Receipt Lists</h4>
          </div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Tournament</a>
            </li>

            <li className="breadcrumb-item active" aria-current="page">
              Receipt Lists
            </li>
          </ol>
        </div>

        <div className="row">
          <div className="col-12">
            <form className="card mt-0">
              <div className="card-body">
                <div className="row pb-3">
                  <div className="col-md-9">
                    <div className="text-left">
                      <h3 className="mb-2">{tname}</h3>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="text-right">
                    <a onClick={explist} className="btn btn-export me-2">
                        <i className="fa-solid fa-file-export"></i> Export
                      </a>
                      <a onClick={backlist} className="btn btn-gray">
                        <i className="fe fe-corner-up-left"></i> Back
                      </a>
                    </div>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="sp-league-table sp-data-table">
                    <thead className="sp-table-header">
                      <tr role="row">
                        <th className="text-center">Action</th>
                        <th className="text-center">School</th>
                        <th className="text-center">Description</th>
                        <th className="text-center">Receipt</th>
                        <th className="text-center">Approve/Reject</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filterProduct.map((item, j) => {
                        const getRowColor = () => {
                          return j % 2 === 0 ? "even" : "odd";
                        };
                        return (
                          <>
                            <tr
                              className={`sp-row-no-0 ${getRowColor()}`}
                              role="row"
                              key={j}
                              // onClick={() => {
                              //   localStorage.getItem("Page", 1);
                              //   dotracking(
                              //     "view individual list of tournament type in dashboard for " +
                              //       item.meet_type +
                              //       " $$ " +
                              //       trackobj.achievelistheading
                              //   );
                              //   navigate(
                              //     "/superadmin/individualachievementlist/" +
                              //       item.meet_type
                              //   );
                              // }}
                            >
                              <td
                                className="data-pct"
                                style={{ cursor: "pointer" }}
                              >
                                <a
                                  className="btn-sm btn-danger me-2"
                                  title="Delete Receipt"
                                  onClick={() => deleterec(item)}
                                >
                                  <i className="fa fa-trash"></i>
                                </a>
                                <a
                                  className="btn-sm btn-secondary"
                                  title="View Summary"
                                  onClick={() => viewrec(item)}
                                >
                                  <i className="fa fa-eye"></i>
                                </a>
                              </td>
                              <td className="data-pct">{item.school_name}</td>
                              <td className="data-pct">{item.receipt_desc}</td>
                              {item.receipt_image !== null && (
                                <td className="data-pct">
                                  <a
                                    onClick={() =>
                                      openimage(spath + item.receipt_image)
                                    }
                                  >
                                    <img
                                      src={spath + item.receipt_image}
                                      height="50px"
                                      width="50px"
                                    />
                                  </a>
                                  {/* {spath + item.receipt_image} */}
                                </td>
                              )}
                              {item.receipt_image === null && (
                                <td className="data-pct">-</td>
                              )}
                              {item.approve_or_reject == 0 && (
                                <td
                                  className="data-pct"
                                  style={{ cursor: "pointer" }}
                                >
                                  <a
                                    className="btn btn-success me-1"
                                    onClick={() => handleshow(1, item)}
                                  >
                                    {" "}
                                    Approve
                                  </a>{" "}
                                  <a
                                    className="btn btn-danger"
                                    onClick={() => handleshow(2, item)}
                                  >
                                    {" "}
                                    Reject
                                  </a>
                                </td>
                              )}
                              {item.approve_or_reject == 1 && (
                                <td className="data-pct">Approved</td>
                              )}
                              {item.approve_or_reject == 2 && (
                                <td className="data-pct">
                                  Rejected - {item.approve_or_reject_reason}
                                </td>
                              )}
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <Modal show={sumshow} size="md">
                  <Modal.Header>View Summary</Modal.Header>
                  <Modal.Body>
                    <h5 className="mb-3 tx-uppercase">
                      Player DETAILs{" "}
                      <span className="float-end">Amount (INR)</span>
                    </h5>
                    <dl className="dlist-align">
                      <dt className="">
                        Number of Men <code>({cmen})</code>
                      </dt>
                      <dd className="text-end ms-auto">{emencnt} Events</dd>
                    </dl>
                    <dl className="dlist-align">
                      <dt>
                        Number of Women <code>({cwomen})</code>
                      </dt>
                      <dd className="text-end ms-auto">{ewomencnt} Events</dd>
                      {/* text-danger  */}
                    </dl>
                    {/* <dl className="dlist-align border-bottom">
                            <dt>
                              Relay Team <code>({rcnt})</code>
                            </dt>
                            <dd className="text-end ms-auto">{ramt} Team</dd>
                          </dl> */}
                    <dl className="dlist-align border-top">
                      <dt>Total Events{/* <code>({tcnt})</code> */}</dt>
                      <dd className="text-end errortext ms-auto">
                        <strong>{etcnt} Events</strong>
                      </dd>
                    </dl>

                    <dl className="dlist-align border-bottom">
                      <dt>
                        Discount <code>({disper} %)</code>
                      </dt>
                      <dd className="text-end ms-auto">{disamt}</dd>
                    </dl>
                    <dl className="dlist-align tx-uppercase">
                      <dt style={{ fontWeight: "bold", color: "#035399" }}>
                        Registration Fee
                      </dt>
                      <dd className="text-end errortext ms-auto">
                        <strong>{regfinalamt}</strong>
                      </dd>
                    </dl>
                    <dl className="dlist-align tx-uppercase">
                      <dt style={{ fontWeight: "bold", color: "#035399" }}>
                        Overall Amount
                      </dt>
                      <dd className="text-end errortext ms-auto">
                        <strong>{finalamt}</strong>
                      </dd>
                    </dl>
                  </Modal.Body>
                  <Modal.Footer>
                    <div className="text-right">
                      {sumrep.approve_or_reject == 0 && (
                        <>
                          <a
                            className="btn btn-success me-1"
                            onClick={() => handleshow(1, sumrep)}
                          >
                            {" "}
                            Approve
                          </a>{" "}
                          <a
                            className="btn btn-danger me-1"
                            onClick={() => handleshow(2, sumrep)}
                          >
                            {" "}
                            Reject
                          </a>
                        </>
                      )}

                      <a className="btn btn-gray" onClick={closesum}>
                        {" "}
                        Close
                      </a>
                    </div>
                  </Modal.Footer>
                </Modal>

                <Modal show={oshow} size="md">
                  <Modal.Header>Receipt</Modal.Header>
                  <Modal.Body>
                    <img src={oimage} />
                  </Modal.Body>
                  <Modal.Footer>
                    <div className="text-right">
                      <a className="btn btn-gray" onClick={closeimage}>
                        {" "}
                        Close
                      </a>
                    </div>
                  </Modal.Footer>
                </Modal>

                <Modal show={show} size="md">
                  <Modal.Header>
                    {rtype == 1 ? "Approve" : "Reject"} Receipt
                  </Modal.Header>
                  <Modal.Body>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="form-label">
                            Notes <span className="errortext"> *</span>
                          </label>
                          <textarea
                            type="text"
                            className="form-control"
                            placeholder="Enter Notes"
                            rows="3"
                            onChange={(e) => setRDesc(e.target.value)}
                            value={rdesc}
                          />
                        </div>
                      </div>
                      {errmsg !== "" && (
                        <span className="errortext"> {errmsg}</span>
                      )}
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <div className="text-right">
                      <a className="btn btn-success me-2" onClick={submitrec}>
                        {" "}
                        Upload
                      </a>
                      <a className="btn btn-gray" onClick={handleclose}>
                        {" "}
                        Close
                      </a>
                    </div>
                  </Modal.Footer>
                </Modal>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
